import React, { useState } from 'react';
import { Button, Table } from 'react-bootstrap';
import moment from 'moment';
import OrderSummary from '../../dashboard/components/order-summary';
import PassbookService from '../../../services/passbook.service';
import Loader from '../../../shared/common/loader';
import { formatAmount } from '../../../utils';
import { userStore } from 'store/UserStore';
import './table.css';
interface PropsType {
  metalData: any;
}

// table sorting start
const useSortableData = (items, config = null) => {
  const [sortConfig, setSortConfig] = React.useState(config);

  const sortedItems = React.useMemo(() => {
    let sortableItems = [...items];
    if (sortConfig !== null) {
      sortableItems.sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      });
    }
    return sortableItems;
  }, [items, sortConfig]);

  const requestSort = (key) => {
    let direction = 'ascending';
    if (
      sortConfig &&
      sortConfig.key === key &&
      sortConfig.direction === 'ascending'
    ) {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

  return { items: sortedItems, requestSort, sortConfig };
};
// table sorting end

const MetalTransactions: React.FC<PropsType> = ({ metalData }) => {
  const [customer, user, customerId] = userStore((state: any) => [
    state.customer,
    state.user,
    state.customerId,
  ]);
  const [selectedMetalData, setSelectedMetalData] = useState<any>(null);
  const [isShow, setIsShow] = useState(false);
  const [loading, setLoading] = useState<any>(false);

  // table sorting start
  const { items, requestSort, sortConfig } = useSortableData(metalData);
  const getClassNamesFor = (name) => {
    if (!sortConfig) {
      return;
    }
    return sortConfig.key === name ? sortConfig.direction : undefined;
  };
  // table sorting start

  /**
   * Set selected wallet data
   * @param data
   */
  const onChangeMetalData = async (data) => {
    await getOrderDetails(data.ebOrderRef);
  };

  /**
   * Change side modal state
   * @param value
   */
  const onHandleSideModal = (value) => {
    setIsShow(value);
  };

  /**
   * Get order details
   * @param orderRef
   */
  const getOrderDetails = async (orderRef) => {
    try {
      setLoading(true);
      const res: any = await PassbookService.getOrderDetails(
        orderRef,
        user?.userId
      );
      if (
        res.status === 200 &&
        res.data.data.result &&
        res.data.data.result.length > 0
      ) {
        setSelectedMetalData(res.data.data.result[0]);
        setLoading(false);
        onHandleSideModal(true);
      }
    } catch (e: any) {
      console.log(e.message);
    }
  };
  return (
    <>
      {selectedMetalData && (
        <OrderSummary
          handleModal={onHandleSideModal}
          isShow={isShow}
          data={selectedMetalData}
          isPassbookRedirect={false}
          displaySummary={true}
          displayInvoice={
            customer?.customerCategory !== 'REGISTERED' ||
            selectedMetalData?.type !== 'BUYBACK'
          }
        />
      )}
      {loading && <Loader />}
      <Table className='mb-0 w-100 txn__table' striped hover responsive>
        <thead>
          <tr>
            <th className='min'>
              <button
                type='button'
                onClick={() => requestSort('ebOrderRef')}
                className={getClassNamesFor('ebOrderRef')}
              >
                Order ID
              </button>
            </th>
            <th>Type</th>
            <th>Order</th>
            <th>
              <button
                type='button'
                onClick={() => requestSort('createdAtUnix')}
                className={getClassNamesFor('createdAtUnix')}
              >
                Date
              </button>
            </th>
            <th>Status</th>
            <th className='min'>
              <button
                type='button'
                onClick={() => requestSort('quotationTotal')}
                className={getClassNamesFor('quotationTotal')}
              >
                Amount
              </button>
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {items.length === 0 && (
            <tr>
              <td className='text-center' colSpan={7}>
                No metal transactions available
              </td>
            </tr>
          )}
          {items.map((metal: any, index: number) => (
            // eslint-disable-next-line react/no-array-index-key
            <tr key={index}>
              <td className='min'>{metal.ebOrderRef}</td>
              <td>
                {metal.order.paymentMethod === 'GIFT'
                  ? 'GIFT'
                  : metal.type === 'SELL'
                  ? 'BUY'
                  : 'SELL'}
              </td>
              {
                metal?.order?.discount?.totalDiscount > 0 ?
                <td>
              
                {metal.type === 'SELL'
                  ? `Bought ${
                      metal.items.length > 0 &&
                      metal.items[0].itemBreakDown.length > 0
                        ? `${formatAmount(
                            metal.items[0].itemBreakDown[0].qty,
                            4
                          )} grams of ${metal.items[0].itemBreakDown[0].name}`
                        : `00 grams`
                    } + ${
                      metal.items.length > 0 &&
                      metal.items[0].itemBreakDown.length > 0
                        ? `${formatAmount(
                            metal.items[0].itemBreakDown[0].qty,
                            4
                          )} grams of Silver free`
                        : `00 grams`
                    } `
                  : metal.order.paymentMethod === 'GIFT'
                  ? metal.order.customerId === customerId
                    ? `Gifted ${
                        metal.items.length > 0 &&
                        metal.items[0].itemBreakDown.length > 0
                          ? `${formatAmount(
                              metal.items[0].itemBreakDown[0].qty,
                              4
                            )} grams of ${metal.items[0].itemBreakDown[0].name}`
                          : `00 grams`
                      }`
                    : `Received Gift ${
                        metal.items.length > 0 &&
                        metal.items[0].itemBreakDown.length > 0
                          ? `${formatAmount(
                              metal.items[0].itemBreakDown[0].qty,
                              4
                            )} grams of ${metal.items[0].itemBreakDown[0].name}`
                          : `00 grams`
                      }`
                  : `Sold ${
                      metal.items.length > 0 &&
                      metal.items[0].itemBreakDown.length > 0
                        ? `${formatAmount(
                            metal.items[0].itemBreakDown[0].qty,
                            4
                          )} grams of ${metal.items[0].itemBreakDown[0].name}`
                        : `00 grams`
                    }`}
              </td> :
               <td>
              
               {metal.type === 'SELL'
                 ? `Bought ${
                     metal.items.length > 0 &&
                     metal.items[0].itemBreakDown.length > 0
                       ? `${formatAmount(
                           metal.items[0].itemBreakDown[0].qty,
                           4
                         )} grams of ${metal.items[0].itemBreakDown[0].name}`
                       : `00 grams`
                   } `
                 : metal.order.paymentMethod === 'GIFT'
                 ? metal.order.customerId === customerId
                   ? `Gifted ${
                       metal.items.length > 0 &&
                       metal.items[0].itemBreakDown.length > 0
                         ? `${formatAmount(
                             metal.items[0].itemBreakDown[0].qty,
                             4
                           )} grams of ${metal.items[0].itemBreakDown[0].name}`
                         : `00 grams`
                     }`
                   : `Received Gift ${
                       metal.items.length > 0 &&
                       metal.items[0].itemBreakDown.length > 0
                         ? `${formatAmount(
                             metal.items[0].itemBreakDown[0].qty,
                             4
                           )} grams of ${metal.items[0].itemBreakDown[0].name}`
                         : `00 grams`
                     }`
                 : `Sold ${
                     metal.items.length > 0 &&
                     metal.items[0].itemBreakDown.length > 0
                       ? `${formatAmount(
                           metal.items[0].itemBreakDown[0].qty,
                           4
                         )} grams of ${metal.items[0].itemBreakDown[0].name}`
                       : `00 grams`
                   }`}
             </td>
}
              <td className='min'>
                {moment(metal.createdAtUnix).format('DD-MMM-yyyy  hh:mm:ss A')}
              </td>
              <td>
                <div className='badge bg-secondary'>
                  {metal.status.split('_').join(' ')}
                </div>
              </td>
              <td className='min'>₹ {formatAmount(metal.quotationTotal)}</td>
              <td>
                <Button
                  variant='primary'
                  onClick={() => onChangeMetalData(metal)}
                  bsPrefix='btn-table'
                  size='sm'
                >
                  View
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </>
  );
};

export default MetalTransactions;
